let maxIndex = 1000
let minIndex = 999

export const getZIndex = () => ++maxIndex

export const getMinIndex = () => --minIndex
